<ngx-charts-pie-chart
  [view]="view"
  [scheme]="colorScheme"
  [animations]="animations"
  [results]="chartData"
  [legend]="showLegend"
  [labels]="showLabels"
  [legendPosition]="legendPosition"
  [labelFormatting]="labelFormatting.bind(this)">
</ngx-charts-pie-chart>
<div class="label">
  <span class="amount">{{formatAmount()}}</span>
  <span class="sub">{{label}}</span>
</div>
